import './services.scss';

import Swiper from 'swiper';
import { AjaxLoader } from '../../js/ajax-loader';
import { checkAndLoadFiles, createElementFromHTML, getOffset, smoothScrollTo } from '../../js/helper';

class Services {
    constructor ($element) {
        this.$services = $element;
        this.$servicesTarget = this.$services.querySelector('[data-services="target"]');
        this.$countrySelect = null;
        this.countrySwitch = null;

        this.topicSlider = [];
        this.addressSlider = [];
        this.$topics = null;
        this.$addresses = null;
        this.$topicsSliderContainer = null;
        this.topicSliderActive = false;
        this.addressSliderActive = false;
        this.$serviceCenterSelectionButtons = null;
        this.animationsSpeed = 500;
        this.wait = false;
        this.selections = {
            country: null,
            subjectType: null,
            serviceCenterId: null
        };

        this.$stepper = this.$services.querySelector('[data-stepper="root"]');
        this.$stepperBack = this.$services.querySelector('[data-stepper-back]');
        this.stepBackTimeout = null;
        this.$stepperChoices = this.$services.querySelector('[data-stepper="choices"]');
        this.$stepperArr = [];
        this.lastID = 0;
        this.baseURL = this.$services.dataset.serviceBaseUrl;
        this.lastURL = this.baseURL;
        this.popStateTimeout = null;
        this.loadServiceTimeout = null;
    }

    initialize () {
        this.setHistory({
            state: 'ajax',
            url: this.baseURL,
            stepperArr: []
        });

        this.initContents();
        this.setEvents();
    }

    initContents () {
        this.$countrySelect = this.$services.querySelector('[data-services="country"]');
        this.$countrySubmit = this.$services.querySelector('[data-services-country-submit]');
        this.$country = this.$services.querySelector('[data-services-country="root"]');
        this.topicSlider = [];
        this.addressSlider = [];
        this.$topics = this.$services.querySelector('[data-services-topics="root"]');
        this.$contactTopics = this.$services.querySelector('[data-services-contact-topics="root"]');
        this.$contactTopicsCloses = this.$contactTopics?.querySelectorAll('[data-services-contact-topics="close"]');
        this.$topicsSliderContainer = this.$services.querySelectorAll('[data-services-topics="slider"]');
        this.$addressSliderContainer = this.$services.querySelectorAll('[data-services-addresses="slider"]');
        this.$topicsOpener = this.$services.querySelectorAll('[data-services-topic-index]');
        this.$targetContainer = this.$services.querySelector('[data-services-topic-targets]');
        this.$servicesTarget = this.$services.querySelector('[data-services="target"]');
        this.topicSliderActive = false;
        this.addressSliderActive = false;
        this.$serviceCenterSelectionButtons = this.$services.querySelectorAll('[data-services-selection-url]');

        if (this.$countrySelect) {
            this.initCountry();
        }

        if (this.$topics || this.$addressSliderContainer) {
            if (this.$topics) {
                this.initTopics();
            }

            this.checkSizes();
        }

        if (this.$serviceCenterSelectionButtons.length > 0) {
            this.setServiceSelectionEvents();
        }

        if (this.$contactTopics) {
            this.initTopicOpener();
        }
    }

    setEvents () {
        window.onpopstate = (e) => {
            clearTimeout(this.popStateTimeout);
            this.$services.classList.add('has--action');

            if (e.state !== null) {
                this.popStateTimeout = setTimeout(() => {
                    this.getHistoryData(history.state, (formData, url) => {
                        this.result = new AjaxLoader(url, {
                            requestMethod: 'POST',
                            requestData: formData,
                            onSuccess: (resultText) => {
                                const results = JSON.parse(resultText);
                                this.setResults(results.html);
                                this.popStateCounter = 0;

                                setTimeout(() => {
                                    this.$services.classList.remove('has--action');
                                }, 200);
                            },
                            onError: (error) => {
                                console.warn(error);
                            }
                        });

                        this.lastURL = url;
                    });
                }, 200);
            }
        };
    }

    setServiceSelectionEvents () {
        this.$serviceCenterSelectionButtons.forEach(($selection) => {
            $selection.addEventListener('click', () => {
                clearTimeout(this.loadServiceTimeout);
                this.$services.classList.add('has--action');

                this.loadServiceTimeout = setTimeout(() => {
                    const url = $selection.dataset.servicesSelectionUrl;
                    this.selections.serviceCenterId = $selection.dataset.servicesSelectionId;
                    this.$servicesTarget.firstElementChild.appendChild(createElementFromHTML(window.OPTIONS.loader));

                    this.loadData(url, 'Service Center', {
                        country: this.selections.country,
                        subjectType: this.selections.subjectType,
                        serviceCenterId: this.selections.serviceCenterId
                    });
                }, 200);
            });
        });
    }

    loadData (url, stepperLabel, options) {
        const formData = new FormData();
        const historyData = {};

        if (typeof options !== 'undefined') {
            if (typeof options.country !== 'undefined') {
                formData.append('country', options.country);
                historyData.country = options.country;
                this.selections.country = options.country;
            }

            if (typeof options.subjectType !== 'undefined') {
                formData.append('subjectType', options.subjectType);
                historyData.subjectType = options.subjectType;
                this.selections.subjectType = options.subjectType;
            }

            if (typeof options.serviceCenterId !== 'undefined') {
                formData.append('serviceCenterId', options.serviceCenterId);
                historyData.serviceCenterId = options.serviceCenterId;
                this.selections.serviceCenterId = options.serviceCenterId;
            }

            historyData.type = 'ajax';
            historyData.url = url;
        }

        smoothScrollTo(0, getOffset(this.$services).top, 100);

        this.result = new AjaxLoader(url, {
            requestMethod: 'POST',
            requestData: formData,
            onSuccess: (resultText) => {
                const results = JSON.parse(resultText);
                this.setResults(results.html);

                if (typeof stepperLabel !== 'undefined' && typeof options !== 'undefined') {
                    historyData.stepperArr = this.$stepperArr;
                    this.setHistory(historyData);
                }

                setTimeout(() => {
                    this.$services.classList.remove('has--action');
                }, 200);
            },
            onError: (error) => {
                console.warn(error);
            }
        });
    }

    initCountry () {
        const cookieAutoBlocking = this.$country.dataset.countryAutoblocking;

        if (cookieAutoBlocking === 'true') {
            let countrySelectLoaded = false;

            const waitForConsent = setInterval(() => {
                if (typeof CookieConsent !== 'undefined') {
                    clearInterval(waitForConsent);

                    if (CookieConsent.consent.marketing === true) { // eslint-disable-line
                        const $mediaRestriction = this.$country.parentElement.querySelector('.media__restriction');

                        if ($mediaRestriction) {
                            $mediaRestriction.remove();
                        }

                        if (!countrySelectLoaded) {
                            // Set the flag to indicate that country selected has been loaded
                            countrySelectLoaded = true;
                            import('../../components/form/select-box').then(({ SelectBox }) => {
                                this.countrySwitch = new SelectBox(this.$countrySelect, {
                                    width: 'auto'
                                });

                                this.$countrySelect.addEventListener('change', () => {
                                    this.loadTopics();
                                });

                                const $errors = this.$country.querySelector('[data-services-error]');

                                if (this.$countrySubmit) {
                                    this.$countrySubmit.addEventListener('click', (e) => {
                                        if (this.$countrySelect.value === '') {
                                            if ($errors) {
                                                $errors.classList.remove('is--hidden');

                                                setTimeout(() => {
                                                    $errors.classList.add('is--hidden');
                                                }, 5000);
                                            }

                                            e.preventDefault();
                                        } else {
                                            if ($errors) {
                                                $errors.classList.add('is--hidden');
                                            }

                                            this.loadTopics();
                                        }
                                    });
                                }
                            });
                        }
                    } else {
                        const $mediaRestriction = this.$country.parentElement.querySelector('.media__restriction');

                        if ($mediaRestriction) {
                            $mediaRestriction.classList.add('is--shown');
                            $mediaRestriction.closest('[data-services-country="root"]')?.classList.add('has--restriction');
                        }
                    }
                } else {
                    console.log('waiting for CookieContent');
                }
            }, 300);

            // timout if cookie consent is not defined - to prevent a permanent loop in the terminal
            setTimeout(() => {
                clearInterval(waitForConsent);
            }, 10000);
        } else {
            import('../../components/form/select-box').then(({ SelectBox }) => {
                this.countrySwitch = new SelectBox(this.$countrySelect, {
                    width: 'auto'
                });

                this.$countrySelect.addEventListener('change', () => {
                    this.loadTopics();
                });

                const $errors = this.$country.querySelector('[data-services-error]');

                if (this.$countrySubmit) {
                    this.$countrySubmit.addEventListener('click', (e) => {
                        if (this.$countrySelect.value === '') {
                            if ($errors) {
                                $errors.classList.remove('is--hidden');

                                setTimeout(() => {
                                    $errors.classList.add('is--hidden');
                                }, 5000);
                            }

                            e.preventDefault();
                        } else {
                            if ($errors) {
                                $errors.classList.add('is--hidden');
                            }

                            this.loadTopics();
                        }
                    });
                }
            });
        }
    }

    loadTopics () {
        const url = this.$countrySelect.dataset.servicesUrl;
        const stepperLabel = this.$countrySelect.querySelector('[selected]').innerText;
        const country = this.$countrySelect.value;

        this.$country.appendChild(createElementFromHTML(window.OPTIONS.loader));

        this.loadData(url, stepperLabel, {
            country: country
        });
    }

    initTopics () {
        const $topics = this.$services.querySelectorAll('[data-services-topics="slide"]');

        $topics.forEach(($topic) => {
            $topic.addEventListener('click', () => {
                if ($topic.dataset.servicesUrl) {
                    this.loadFormular($topic);
                } else {
                    if ($topic.dataset.servicesExternal !== '') {
                        window.open($topic.dataset.servicesExternal, '_blank');
                    }
                }
            });
        });
    }

    loadFormular ($topic) {
        const url = $topic.dataset.servicesUrl;
        const stepperLabel = $topic.dataset.servicesStepperLabel;
        const subjectType = $topic.dataset.servicesSubjectType;
        const country = this.selections.country;
        this.$topics.appendChild(createElementFromHTML(window.OPTIONS.loader));

        this.loadData(url, stepperLabel, {
            country: country,
            subjectType: subjectType
        });
    }

    initTopicSlider () {
        this.topicSliderActive = true;

        this.$topicsSliderContainer.forEach((slider, index) => {
            this.topicSlider[index] = new Swiper(slider, {
                slidesPerView: 'auto',
                spaceBetween: 16,
                speed: 500,
                autoHeight: false,
                pagination: {
                    el: slider.nextElementSibling.querySelector('.swiper-pagination'),
                    type: 'progressbar'
                }
            });
        });
    }

    initAddressSlider () {
        this.addressSliderActive = true;

        this.$addressSliderContainer.forEach((slider, index) => {
            if (slider.querySelectorAll('[data-services-addresses="slide"]').length > 1) {
                this.addressSlider[index] = new Swiper(slider, {
                    slidesPerView: 'auto',
                    spaceBetween: 16,
                    speed: 500,
                    autoHeight: true,
                    observer: true,
                    threshold: 5,
                    pagination: {
                        el: slider.nextElementSibling.querySelector('.swiper-pagination'),
                        type: 'progressbar'
                    }
                });

                const $accordionInputs = slider.querySelectorAll('input.checkbox__hidden');

                if ($accordionInputs.length > 0) {
                    $accordionInputs.forEach((input) => {
                        input.addEventListener('change', () => {
                            if (window.innerWidth < 1024) {
                                for (let i = 0; i < 5; i++) {
                                    setTimeout(() => {
                                        this.addressSlider[index].update();
                                    }, i * 50);
                                }
                            }
                        });
                    });
                }
            }
        });
    }

    setResults (results) {
        const $origin = this.$servicesTarget.firstElementChild;
        const $results = createElementFromHTML(results);

        if ($results.length > 1) {
            $results.forEach((element) => {
                this.$servicesTarget.appendChild(element);
            });
        } else {
            this.$servicesTarget.appendChild($results);
            const $activeContent = this.$servicesTarget.querySelector('[data-services-contact="root"]');
            if ($activeContent) {
                $activeContent.setAttribute('tabindex', '0');
                $activeContent.focus();
                $activeContent.removeAttribute('tabindex');
            }
        }

        $origin.style.height = $origin.scrollHeight + 'px';
        $origin.classList.add('has--height');

        setTimeout(() => {
            $origin.remove();

            $results.style.height = $results.scrollHeight + 'px';
            $results.style.filter = 'blur(0)';

            setTimeout(() => {
                $results.style.filter = '';
                $results.classList.remove('has--height');
                $results.style.height = '';
                this.initContents();
            }, this.animationsSpeed);
        }, this.animationsSpeed);

        checkAndLoadFiles(this.$servicesTarget).then((data) => {
            window.dispatchEvent(new CustomEvent('content.loaded', {
                view: window,
                bubbles: true,
                cancelable: false,
                detail: {
                    $context: this.$servicesTarget
                }
            }));
        });
    }

    destroyTopicSlider () {
        for (let i = 0; i < this.topicSlider.length; i++) {
            if (this.topicSlider[i] !== null) {
                this.topicSlider[i].destroy(true, true);
                this.topicSlider[i] = null;
                this.topicSliderActive = false;
            }
        }
    }

    destroyAddressSlider () {
        for (let i = 0; i < this.addressSlider.length; i++) {
            if (this.addressSlider[i] !== null) {
                this.addressSlider[i].destroy(true, true);
                this.addressSlider[i] = null;
                this.addressSliderActive = false;
            }
        }
    }

    initTopicOpener () {
        this.$topicsOpener.forEach(($topic) => {
            $topic.addEventListener('click', () => {
                if (!this.wait) {
                    if (typeof $topic.dataset.servicesExternal === 'undefined') {
                        this.openTopic($topic);
                    } else {
                        if ($topic.dataset.servicesExternal !== '') {
                            window.open($topic.dataset.servicesExternal, '_blank');
                        }
                    }
                }
            });
        });

        this.$contactTopicsCloses.forEach(($closeButton) => {
            $closeButton.addEventListener('click', () => {
                this.closeActiveTopic();
                smoothScrollTo(0, getOffset(this.$contactTopics).top, 100);
            });
        });
    }

    openTopic (topic) {
        const $targetTopic = this.$targetContainer.querySelector('[data-services-topic-target="' + topic.dataset.servicesTopicIndex + '"]');

        if ($targetTopic) {
            if (!topic.classList.contains('is--active')) {
                this.closeActiveTopic(() => {
                    $targetTopic.style.height = $targetTopic.scrollHeight + 'px';
                    topic.classList.add('is--active');

                    smoothScrollTo(0, getOffset(this.$targetContainer).top, 100);

                    setTimeout(() => {
                        $targetTopic.style.height = 'auto';
                        this.wait = false;
                    }, this.animationsSpeed);
                });
            } else {
                this.closeActiveTopic();
            }
        }
    }

    closeActiveTopic (callback) {
        const $activeTopic = this.$services.querySelector('[data-services-topic-index].is--active');

        if ($activeTopic) {
            const $activeTopicTarget = this.$targetContainer.querySelector('[data-services-topic-target="' + $activeTopic.dataset.servicesTopicIndex + '"]');

            $activeTopicTarget.style.height = $activeTopicTarget.scrollHeight + 'px';
            $activeTopic.classList.remove('is--active');
            this.wait = true;

            setTimeout(() => {
                $activeTopicTarget.style.height = '0px';
            }, 50);

            setTimeout(() => {
                this.wait = false;

                if (typeof callback === 'function') {
                    callback();
                }
            }, this.animationsSpeed.speed + 50);
        } else {
            if (typeof callback === 'function') {
                callback();
            }
        }
    }

    checkSizes () {
        if (!window.mediaMatch[768].matches) {
            this.initTopicSlider();
        }

        if (!window.mediaMatch[1024].matches) {
            if (this.$addressSliderContainer) {
                this.initAddressSlider();
            }
        }

        window.mediaMatch[768].addEventListener('change', (match) => {
            if (!match.matches && !this.topicSliderActive) {
                this.initTopicSlider();
            }

            if (match.matches) {
                if (this.topicSliderActive) {
                    this.destroyTopicSlider();
                }
            }
        });

        window.mediaMatch[1024].addEventListener('change', (match) => {
            if (!match.matches && !this.addressSliderActive) {
                this.initAddressSlider();
            }

            if (match.matches) {
                if (this.addressSliderActive) {
                    this.destroyAddressSlider();
                }
            }
        });
    }

    setHistory (historyData) {
        history.pushState(historyData, '', window.location.href);
    }

    getHistoryData (data, callback) {
        const formData = new FormData();

        for (const key in data) {
            formData.append(key, data[key]);
        }

        if (typeof callback === 'function') {
            callback(formData, data.url);
        }
    }
}

export { Services };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $services = $context.querySelector('[data-services="root"]');

        if ($services) {
            const $Services = new Services($services);
            $Services.initialize();
        }
    }
});
